import { Controller } from "@hotwired/stimulus"

// Toggles every <details> row in the violations list open/closed in one click.
// Targets:
//   - details: each <details> element representing a violation row
//   - label:   the text node inside the button, flipped between
//              "Expand all" and "Collapse all" to reflect the next action
export default class extends Controller {
  static targets = ["details", "label"]

  toggle() {
    const anyClosed = this.detailsTargets.some(d => !d.open)
    const newState = anyClosed
    this.detailsTargets.forEach(d => { d.open = newState })
    this.updateLabel()
  }

  updateLabel() {
    if (!this.hasLabelTarget) return
    const allOpen = this.detailsTargets.length > 0 &&
                    this.detailsTargets.every(d => d.open)
    this.labelTarget.textContent = allOpen ? "Collapse all" : "Expand all"
  }
}
